import React, { useEffect, useState } from 'react'
import { useGetUser } from '../../../hooks/useGetUser';
import { FormControl, TextField, InputLabel, Select, Checkbox, FormControlLabel, MenuItem } from '@material-ui/core'

import Participantes from './Components/Participantes'
import styles from './styles.module.scss'
import { useHistory } from 'react-router-dom'
import services from '../../../services'
import { getParceirosById, postParceiros, ativarInativarParceirosById, getRegional, getFilial, getPorteList, getParticipantesDeParceirosById } from '../../../services/api-auto'

import { useDispatch } from 'react-redux';
import {
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';
import ModalLoading from '../../../components/ModalLoading'
import Voltar from '../../../components/VoltarBtn/voltar'
import AcoesUser from '../../../components/ButtonsAcoes';


const Detalhes = () => {
    const history = useHistory();
    const [data, setData] = useState({
        parceiroId: "",
        razaoSocial: "",
        nomeFantasia: "",
        cnpj: "",
        codigoParceiro: "",
        regional: "",
        filial: "",
        grupoEconomico: "",
        porte: 0,
        tipo: 1
    })
    const [parceiroID, setParceiroId] = useState('')
    const [novoCadastro, setNovoCadastro] = useState(true)
    const [participantes, setParticipantes] = useState([])
    const [filialOptions, setFilialOptions] = useState([])
    const [indicarErros, setIndicarErros] = useState(false)
    const [loading, setLoading] = useState(false)
    const [permiteAdicionarParticipante, setPermiteAdicionarParticipante] = useState(services.storage.getClaimValues("Participantes", "Cadastrar"));
    const [permiteAlterarPDV, setPermiteAlterarPDV] = useState(services.storage.getClaimValues("PDV", "Alterar"));
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const user = useGetUser();

    const tipos = [
        {
            idTipoParceiro: 1,
            sigla: "Concessionária"
        }, {
            idTipoParceiro: 2,
            sigla: "Loja"
        }, {
            idTipoParceiro: 4,
            sigla: "Autoshopping"
        }, 
        {
            idTipoParceiro: 5,
            sigla: "Empresa Conveniada - Privada"
        },
        {
            idTipoParceiro: 6,
            sigla: "Empresa Conveniada - Publica"
        }
        , {
            idTipoParceiro: 7,
            sigla: "Loja Autorizada"
        },
        {
            idTipoParceiro: 8,
            sigla: "Parceiro de indicação - Canal Próprio"
        } ,
        {
            idTipoParceiro: 9,
            sigla: "Parceiro de indicação - Consignado"
        },
        {
            idTipoParceiro: 10,
            sigla: "Promotora"
        }

    ]
    const [regionalOptions, setRegionalOptions] = useState([]);
    const [porteOptions, setPorteOptions] = useState([]);

    useEffect(() => {
        getRegionalData();
        getPorteData();

        const parceiro = new URLSearchParams(history.location.search).get('parceiro');
        if (parceiro) {
            setNovoCadastro(false)
            setParceiroId(parceiro)
            getCampanhaIfEdit(parceiro);
            getParticipantes(parceiro);
        }
    }, [])

    const getCampanhaIfEdit = async (parceiro) => {
        setLoading(true)
        try {
            const info = await getParceirosById(parceiro);
            setData({
                parceiroId: info.data.parceiroId,
                razaoSocial: info.data.razaoSocial,
                nomeFantasia: info.data.nomeFantasia,
                cnpj: info.data.cnpj,
                codigoParceiro: info.data.codigoParceiro,
                regional: info.data.regional,
                filial: info.data.filial,
                grupoEconomico: info.data.grupoEconomico,
                porte: info.data.porte,
                tipo: info.data.tipo,
                ativo: info.data.ativo
            })
            getFilialData(info.data.regional)
        } catch (e) {
            showMsgE("Ocorreu um erro e não foi possível carregar os dados")
        } finally {
            setLoading(false)
        }
    }

    const getRegionalData = async () =>{
        const info = await getRegional();
        setRegionalOptions(info);
    }

    const getFilialData = async (regional) => {
        const info = await getFilial(regional);
        setFilialOptions(info)
    }

    const getPorteData = async () =>{
        const portes = await getPorteList();
        setPorteOptions(portes);
    }

    const salvar = async () => {
        setIndicarErros(false);
        if (validarForm()) {
            setLoading(true)
            try {
                let send = { ...data };
                send.cnpj = services.mask.unMask(send.cnpj)
                send.grupoEconomico = services.mask.unMask(send.grupoEconomico)
                if (!parceiroID) { delete send.parceiroId; }

                const info = await postParceiros(send)

                if (info.statusCode === 200) {
                    showMsgS("Cadastro realizado com sucesso")
                    setTimeout(() => {
                        history.push('/parceiros')
                    }, 2000)
                }

            } catch (e) {
                showMsgE(e.response.data)
            } finally {
                setLoading(false)
            }
        }
    }

    const validarForm = () => {
        let valid = true;
        let msg = '';

        if (
            data.razaoSocial === "" ||
            data.nomeFantasia === "" ||
            data.cnpj === "" ||
            !data.tipo
        ) {
            msg = 'Informe todos os campos';
            valid = false;
            setIndicarErros(true);
        }
        if (!services.validate.valideCnpj(data.cnpj)) {
            msg = 'CNPJ inválido';
            valid = false;
            setIndicarErros(true);
        }

        if (msg) {
            showMsgW(msg);
        } else {
            if (!valid) showMsgW('Informe todos os campos');
        }
        return valid;
    };

    const getParticipantes = async (parceiro) => {
        const info = await getParticipantesDeParceirosById(parceiro)
        setParticipantes(info.data)
    }

    const ativarDesativar = async () => {
        setLoading(true)

        try {
            await ativarInativarParceirosById(data.parceiroId);
            showMsgS(data.ativo ? "Usuário Inativado com sucesso" : "Usuário Ativado com sucesso")
            history.push('/parceiros');

        } catch (e) {
            showMsgE(data.ativo ? "Erro ao inativar usuário" : "Erro ao ativar usuário")
        } finally {
            setLoading(false)
        }
    };
    useEffect(() => { }, [data])

    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    Ponto de Venda
                    <Voltar />
                </div>
                <div className={styles.blueBackground}>
                    <div className={styles.content}>
                        <div className={styles.card}>
                            <FormControl className={styles.half}>
                                <TextField
                                    type="text"
                                    size="small"
                                    onChange={(e) => { setData({ ...data, cnpj: e.target.value }); }}
                                    label="CNPJ"
                                    value={services.mask.cnpj(data.cnpj)}
                                    variant="filled"
                                    error={indicarErros && !data.cnpj ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAlterarPDV}
                                />
                            </FormControl>
                            <FormControl className={styles.half}>
                                <TextField
                                    type="text"
                                    size="small"
                                    onChange={(e) => { setData({ ...data, codigoParceiro: e.target.value }); }}
                                    label="Código Parceiro"
                                    value={data.codigoParceiro}
                                    inputProps={{
                                        maxLength: 6
                                    }}
                                    variant="filled"
                                    error={indicarErros && !data.cnpj ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAlterarPDV}
                                />
                            </FormControl>
                            <FormControl className={styles.half}>
                                <TextField
                                    type="text"
                                    size="small"
                                    onChange={(e) => { setData({ ...data, razaoSocial: e.target.value }); }}
                                    label="Razão Social"
                                    value={data.razaoSocial}
                                    variant="filled"
                                    error={indicarErros && !data.razaoSocial ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAlterarPDV}
                                />
                            </FormControl>
                            <FormControl className={styles.half}>
                                <TextField
                                    type="text"
                                    size="small"
                                    onChange={(e) => { setData({ ...data, nomeFantasia: e.target.value }); }}
                                    label="Nome Fantasia"
                                    value={data.nomeFantasia}
                                    variant="filled"
                                    error={indicarErros && !data.nomeFantasia ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAlterarPDV}
                                />
                            </FormControl>
                            <FormControl className={styles.half}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Regional
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="Regional"
                                    onChange={(e) => { setData({ ...data, regional: e.target.value }); getFilialData(e.target.value); }}
                                    value={data.regional}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={!permiteAlterarPDV}
                                >
                                    {
                                        regionalOptions.map((item) => {
                                            return (
                                                <MenuItem value={item} key={item}>
                                                    {item}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl className={styles.half}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Filial
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="Filial"
                                    onChange={(e) => { setData({ ...data, filial: e.target.value }); }}
                                    value={data.filial}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={!permiteAlterarPDV}
                                >
                                    {
                                        filialOptions.map((item) => {
                                            return (
                                                <MenuItem value={item} key={item}>
                                                    {item}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl className={styles.half}>
                                <TextField
                                    type="text"
                                    size="small"
                                    onChange={(e) => { setData({ ...data, grupoEconomico: e.target.value }); }}
                                    label="Grupo Econômico"
                                    value={services.mask.cnpj(data.grupoEconomico)}
                                    variant="filled"
                                    error={indicarErros && !data.grupoEconomico ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAlterarPDV}
                                />
                            </FormControl>
                            <FormControl className={styles.half}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Porte
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="Porte"
                                    onChange={(e) => { setData({ ...data, porte: e.target.value }); }}
                                    value={data.porte}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={!permiteAlterarPDV}
                                >
                                    {
                                        porteOptions.map((item) => {
                                            return (
                                                <MenuItem value={item.porteId} key={item.porteId}>
                                                    {item.descricao}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl className={styles.half}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Tipo
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="Tipo"
                                    onChange={(e) => { setData({ ...data, tipo: e.target.value }); }}
                                    value={data.tipo}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={!permiteAlterarPDV}
                                >
                                    {
                                        tipos.map((item) => {
                                            return (
                                                <MenuItem value={item.idTipoParceiro} key={item.idTipoParceiro}>
                                                    {item.sigla}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    {
                        (permiteAlterarPDV) ? (
                            <div className={styles.blueBackground}>
                                <div className={styles.content}>
                                    <div className={styles.card}>

                                        {<AcoesUser status={novoCadastro ? "Novo" : data.ativo ? "Ativo" : "Inativo"}
                                            key={user.userId}
                                            encerrar={ativarDesativar}
                                            enviar={salvar}
                                            disabled={false}
                                            msgDialog={'Deseja cancelar esta ação? Todos os dados não salvos serão perdidos.'}
                                            redirect={`/parceiros`}
                                            claimName={'PDV'}
                                        />}
                                    </div>
                                </div>
                            </div>
                        ) : null
                    }

                </div>
                {
                    
                        <Participantes participantes={participantes} setParticipantes={setParticipantes} parceiro={parceiroID} />
                    
                }

            </div>
            <ModalLoading
                open={loading}
                size="lg"
            />
        </>
    )
}

export default Detalhes